<div class="login-as-header" *ngIf="isImpersonated()">
  <div class="login-as-content">
    <span>IMPERSONATED</span>
  </div>
</div>

<router-outlet></router-outlet>
